import { useQuery } from '@tanstack/react-query';
import { selfEmploymentQueries } from '../api/self-employment-queries';
import type { OfdLogsFilter } from '../api/self-employment-api';
import type { SelfEmployedListFilter } from '../lib/filters';

/** One page of the self-employment report. */
export function useSelfEmployedList(filter: SelfEmployedListFilter) {
  return useQuery(selfEmploymentQueries.list(filter));
}

/** A courier's OFD status history (fetched only while its dialog is open). */
export function useOfdStatusLogs(filter: OfdLogsFilter, enabled: boolean) {
  return useQuery(selfEmploymentQueries.ofdLogs(filter, enabled));
}
